export default __webpack_public_path__ + "1698f70af4d61a58590c2bcdbc29bfb9.png";